import React, { useEffect } from 'react'
import _ from 'lodash'
import axios from 'axios'
import { History, Location } from 'history'
import { Link, generatePath } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import CopyToClipboard from 'react-copy-to-clipboard'
import { Button, Divider, Table, notification } from 'antd'

import { Page } from '../../components/Page'
import { Layout } from '../../components/Page/Layout'
import { Title } from '../../components/Text'
import { getFlows } from '../../features/flow/selectors'
import { FlowActions } from '../../features/flow/actions'
import { Flow } from '../../features/flow/types'
import { FLOW_DETAIL, ADD_FLOW } from '../../routes'

interface FlowContainerProps {
  history: History
  location: Location<{ showInDashboard?: boolean } | undefined>
}

export const FlowContainer: React.FC<FlowContainerProps> = ({ history }: FlowContainerProps) => {
  const dispatch = useDispatch()
  const flows = useSelector(getFlows)

  useEffect(() => {
    dispatch(FlowActions.fetchFlows())
  }, [dispatch])

  const editFlow = (f: Flow) => {
    history.push(generatePath(FLOW_DETAIL, { flowId: f.id }))
  }

  const testFlow = async (f: Flow) => {
    const resp = await axios.get(`/flows/test/${f.id}`)
    if (resp.data.success) {
      window.open('http://site-collaudo.caldetentazioni.com/?q=ddbcmrg8sovavv10i38376cc', '_blank')
    }
  }

  const duplictaeFlow = async (f: Flow) => {
    const resp = await axios.post(`/copy_flow`, { flowId: f.id })
    if (resp.data.success) {
      const newId = resp.data.data.id || ''
      notification.success({
        description: `nuovo ID: ${newId} <br />nome: ${resp.data.data.name}`,
        message: 'Flusso copiato'
      })
    }
  }

  const dataSource = _.map(_.orderBy(flows, ['createdAt'], ['desc']), (flow: Flow) => {
    return {
      id: flow.id,
      key: flow.id,
      name: flow.name,
      chatPatternId: flow.chatPatternId,
      paymentTemplateId: flow.paymentTemplateId,
      radar: flow.radar,
      chat: flow.chat,
      profile: flow.profile,
      notifications: flow.notifications,
      match: flow.match,
      config: flow.config,
      patternId: flow.patternId
    }
  })

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      // eslint-disable-next-line react/display-name
      render: (text: string) => (
        <div>
          {text}
          <Divider type="vertical" />
          <CopyToClipboard
            text={text}
            onCopy={() => {
              notification.success({
                description: text,
                message: 'ID copiato'
              })
            }}
          >
            <Button type="ghost">COPY</Button>
          </CopyToClipboard>
        </div>
      )
    },
    {
      title: 'Action',
      key: 'action',
      // eslint-disable-next-line react/display-name
      render: (text: string, record: Flow) => (
        <span>
          <Button type="primary" onClick={() => editFlow(record)}>
            Edit
          </Button>
          <Divider type="vertical" />
          <Button type="default" onClick={() => duplictaeFlow(record)}>
            Duplicate
          </Button>
          <Divider type="vertical" />

          <Button type="ghost" onClick={() => testFlow(record)}>
            Test
          </Button>
        </span>
      )
    }
  ]

  return (
    <Page>
      <Layout>
        <Title size="XL">Flows</Title>
        <div>
          <Link to={ADD_FLOW}>
            <Button>Nuovo</Button>
          </Link>
        </div>
        <br />
        <Table dataSource={dataSource} columns={columns} />
      </Layout>
    </Page>
  )
}
